export * from '../../Config/constants/';
export const REFRESH_ERROR_ALERT = 'Refresh not available at this time. Please log in again.';

export const AUTH_STORAGE = 'neusec_auth';
export const AUTH_STORAGE_T = 't';
export const AUTH_STORAGE_E = 'e';
